module.exports = __webpack_public_path__ + "static/media/servImg6.bdafac6a.svg";